module.exports = __webpack_public_path__ + "media/images/sp/stores/kobe/kobe_sns_04-7ccd90a5318e76ae6819de7eb24a86a7.jpg";